import React, {createContext} from 'react';

//types
import {GlobalTranslation} from './types';


export const TranslationsContext = createContext<
  GlobalTranslation | null | undefined
>(null);

export function TranslationsProvider({
  children,
  translations,
}: {
  children: React.ReactNode;
  translations: GlobalTranslation | undefined | null;
}) {
  return React.createElement(
    TranslationsContext.Provider,
    {
      value: translations,
    },
    children,
  );
}
